/** Very basic form validation
 *  ------------------------------------------------------------------------------------------------
 *  ref: https://daverupert.com/2017/11/happier-html5-forms/
**/


/** Action functions
 *  ------------------------------------------------------------------------------------------------
**/
const iAmInvalid = (e) => {
	e.currentTarget.classList.add('js--invalid-input');
};

const validateMe = (e) => {
	if (e.currentTarget.type === 'number') {
		// strip leading 0 but allow 0 on it's own
		// ^0+ matches one or more 0 characters at the start of a word
		// the (?=.+) is a positive lookahead meaning it has to be followed by one or more chars
		e.currentTarget.value = e.currentTarget.value.replace(/^0+(?=.+)/, '');
	}
	e.currentTarget.checkValidity();
};

/** Initialise listeners
 *  ------------------------------------------------------------------------------------------------
**/
export const init = () => {
	const inputs = document.querySelectorAll('.js--validate-me input, .js--validate-me select, .js--validate-me textarea');

	(inputs || []).forEach((input) => {
		input.addEventListener('invalid', iAmInvalid, false);
		input.addEventListener('blur', validateMe, false);
	});
};

export default init;
